export const awsCountryAllowedMessage =
  'Your company is from the AWS approved seller country list.'

export const sellerCountryAdvisorySupportUrl =
  'https://helpcenter.labra.io/hc/en-us?_gl=1*chirg1*_ga*MjA0Mjg1NjY3Ni4xNzAzNTY1NDI1*_ga_HF8SBE4FZ5*MTcxODA5MTMzOC40Ny4xLjE3MTgwOTEzNDEuNTcuMC4w'
